 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		1: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~intl-relativetimeformat~polyfills","2":"lang_af","3":"lang_ar","4":"lang_be","5":"lang_bg","6":"lang_bs","7":"lang_ca","8":"lang_cs","9":"lang_da","10":"lang_de","11":"lang_el","12":"lang_es","13":"lang_et","14":"lang_fi","15":"lang_fil","16":"lang_fr","17":"lang_he","18":"lang_hi","19":"lang_hr","20":"lang_hu","21":"lang_id","22":"lang_is","23":"lang_it","24":"lang_ja","25":"lang_ka","26":"lang_kk","27":"lang_ko","28":"lang_ky","29":"lang_lt","30":"lang_lv","31":"lang_nl","32":"lang_no","33":"lang_pa","34":"lang_pl","35":"lang_pt","36":"lang_pt_br","37":"lang_ro","38":"lang_ru","39":"lang_sk","40":"lang_sl","41":"lang_sq","42":"lang_sr","43":"lang_sr_me","44":"lang_sv","45":"lang_sw","46":"lang_th","47":"lang_tr","48":"lang_tw","49":"lang_uk","50":"lang_ur","51":"lang_uz","52":"lang_vi","53":"lang_zh_cn","54":"lang_zh_tw","55":"locale_ak","56":"locale_ar","57":"locale_be","58":"locale_bg","59":"locale_bs","60":"locale_ca","61":"locale_cs","62":"locale_da","63":"locale_de","64":"locale_el","65":"locale_en","66":"locale_es","67":"locale_et","68":"locale_fi","69":"locale_fil","70":"locale_fr","71":"locale_he","72":"locale_hi","73":"locale_hr","74":"locale_hu","75":"locale_id","76":"locale_is","77":"locale_it","78":"locale_ja","79":"locale_ka","80":"locale_kk","81":"locale_ko","82":"locale_ky","83":"locale_lt","84":"locale_lv","85":"locale_nl","86":"locale_pa","87":"locale_pl","88":"locale_pt","89":"locale_ro","90":"locale_ru","91":"locale_sk","92":"locale_sl","93":"locale_sq","94":"locale_sr","95":"locale_sr_cyrl_me","96":"locale_sv","97":"locale_sw","98":"locale_th","99":"locale_tr","100":"locale_uk","101":"locale_ur","102":"locale_uz","103":"locale_vi","104":"locale_zh","105":"loclae_af","106":"polyfills","107":"pubnub","111":"vendors~polyfills","112":"vendors~pubnub"}[chunkId]||chunkId) + "." + {"0":"b05331f9bf32c32ea72f","2":"3f774ac01a69a1a6a3d6","3":"4e52f9b142624401c235","4":"558bd187e38c09c902c9","5":"c7c568204bb99049fbc5","6":"f00b63d27f44b094064d","7":"b0ef4af3bee5719a73ab","8":"0401107a282a88fb0e95","9":"024a4757df584a41ba9f","10":"ebb88be878d551c78e63","11":"e5ddb23449ae4a029c61","12":"e76f4345656650e29a1b","13":"88469bb6fa4b69208bf5","14":"70d81fb4c887c3c82c06","15":"57d642c8f83fce9335fd","16":"7fd53991f783498fbe49","17":"26c12a104c0f942c7d30","18":"2bd76ad04a97ed48fc9d","19":"3e0deb5eb23a1d41e0c2","20":"16ce9d8a65560298ba80","21":"c7a57e3a819eb3228758","22":"518e9d3cafecb8a70d21","23":"ea053b3585437be0ff23","24":"53b7b3add7dfe4596b2c","25":"fccfdd471cf13be07ba3","26":"1e742b614fd81b2737f1","27":"5f3a202f8fbf21a8f6a0","28":"db469305282bcf23d2a7","29":"43a9deb51be5faa6047f","30":"6274203bf53cee7d6ef6","31":"317a4ba2a3da74c5d0d6","32":"6da6ef2c0de6151052af","33":"a35973cbb83b04bea59e","34":"bb7bf0fbb443e773bd48","35":"c4f45b091a8884f34d9c","36":"6450f418e246c1d04ffc","37":"9d60ee195e316d2a3a86","38":"ebbf8511fc41a1723fca","39":"71c949b38b977efa3c52","40":"4759c606823bcf3a8ffa","41":"41b2e8059758e4f2fdb9","42":"6ff44a6edeb837bd8fc2","43":"66cebf626458bda88024","44":"40b8f52854924f4f1d90","45":"119bd9af0d4049861725","46":"dea375bbafcf8b8bad40","47":"bf542ae95f25985bfcd6","48":"01b8410426f645f92677","49":"f70c75b5f56a439d2154","50":"30549ddc94452223adc2","51":"b86ef128dfdbcad69102","52":"da0c918c55438eb1bd74","53":"ab4a5ac0dc21e34d7f7c","54":"3b4cdfe4d847638d1324","55":"9f2bb225b8d5c1aa3787","56":"5f8b2ad2bdc9d0e8b0bb","57":"b19ea369530bd82b82ae","58":"8da82a7b2fc1c5de46fe","59":"556bc722ed39c31f583b","60":"22e7b2caf84870caf8ba","61":"03b962671ecdd548f04c","62":"264f3771d8ee6cfc8445","63":"0d510035a644af3675d1","64":"78a7d3d583e9ccd2a8cb","65":"2a0641f28d1eb9c482dd","66":"040c6fd5e8f87a9069c0","67":"0d7a87309ae6ba0291d7","68":"066fea3eb31665261479","69":"c71dadca9653596405c1","70":"4e9249980c084d3b63c1","71":"d0c6c702a7c5b6500275","72":"af8016c8cafd22e61874","73":"94fd5d675416df46df8b","74":"b30cee6e7eec03dcafd0","75":"d3acc7f9558d8d3b8b2e","76":"88f827297924af3f3ef6","77":"dc508cf4ad3ab17ddfb1","78":"ca7cdafcac73b0effec0","79":"edc403f85067726cf56c","80":"64aa54f6c988ef08bdc0","81":"3f16dbc73722ea5eb3e9","82":"b4a6d4925e0717cfcea8","83":"dba1c8f17be5cd8a5d67","84":"b5bb04ac01ac786bbf25","85":"3058584bee3b5eaba555","86":"b536413e2936de4641c2","87":"3cfd4eff8b5820d9cbaf","88":"8f4db87e3e8c9d9bc54f","89":"7c4a317b5ef7fd72ac5a","90":"16eef0501e8507729ab8","91":"58627a81e544963ab1fa","92":"ab802d46166f4a5e0f59","93":"e9ff8f27dbc765a57e44","94":"d6763f86c16f037b0cca","95":"6a2f5637db941b0f7c6d","96":"cf301f222555c51e1363","97":"8d016c8769396721429d","98":"02134f91ca71a73485b3","99":"422e7c5c14e0ab83e44b","100":"f460673e2e6ad44af6c7","101":"7481f2ee5377b0cc6a3b","102":"bc4d76a35e1f6e8f080b","103":"2a2ba204cd927032d8ac","104":"e2e18ff27a8322d515b4","105":"8e9a03122ab95408081d","106":"7f7f28bdec33977704c6","107":"f7e5402c295f1497a306","111":"c1e2d01cc151a969f2cf","112":"a3c00f4349eb7482efa5"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.kustomerapp.com/chat-web/release-v0.1.222/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["kustomer_chat_webpackJsonp"] = window["kustomer_chat_webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 98);
